import { createSlice } from '@reduxjs/toolkit'

export const linkedinSlice = createSlice({
  name: 'linkedin',
  initialState: {
    code: {},
  },
  reducers: {
    updateLinkedinLogin: (state, newValue) => {
      state.code = newValue.payload
    },
  },
})

export const { updateLinkedinLogin } = linkedinSlice.actions;

export const selectLinkedin = (state) => state.linkedin.code;

export default linkedinSlice.reducer